import * as React from "react";
import Svg, { Path } from "react-native-svg";

function ProfileDrawerIcon(props) {
  return (
    <Svg {...props} width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M12 12c2.486 0 4.5-2.014 4.5-4.5S14.486 3 12 3a4.499 4.499 0 00-4.5 4.5C7.5 9.986 9.514 12 12 12zm0 2.25c-3.004 0-9 1.508-9 4.5v1.125C3 20.494 3.506 21 4.125 21h15.75c.619 0 1.125-.506 1.125-1.125V18.75c0-2.992-5.996-4.5-9-4.5z"
        fill="#000"
        fillOpacity={0.7}
      />
    </Svg>
  );
}

export default ProfileDrawerIcon;
